export default {
  methods: {
    resetPrevLoading() {
      this.disableLoading = false;
      this.page = 0;
      this.items = [];
    },
  },
};
